import { Box, Grid } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import SectionHeading from './SectionHeading';
import ChannelCard from '../commons/ChannelCard';
import { HELP_MAX_WIDTH, helpColors } from '../style/helpStyles';

const CHANNELS = [
  {
    id: 'whatsapp',
    label: i18n.infoWhatsapp,
    value: i18n.infoWhatsappNumber,
    href: 'https://wa.me/5491164575091',
    Icon: WhatsAppIcon,
    isExternal: true,
  },
  {
    id: 'mail',
    label: i18n.infoMail,
    value: i18n.infoMailClient,
    href: `mailto:${i18n.infoMailClient}`,
    Icon: MailOutlineIcon,
  },
  {
    id: 'phone',
    label: i18n.infoTelephone,
    value: i18n.infoTelephoneNumber,
    href: `tel:${i18n.infoTelephoneNumber.replace(/\s/g, '')}`,
    Icon: PhoneIphoneIcon,
  },
];

const HelpChannels = ({ isMobile }) => (
  <Box
    component="section"
    sx={{
      backgroundColor: helpColors.bg2,
      padding: isMobile ? '40px 20px 48px' : '56px 24px 72px',
    }}
  >
    <Box sx={{ maxWidth: HELP_MAX_WIDTH, margin: '0 auto' }}>
      <SectionHeading
        eyebrow={i18n.helpChannelsEyebrow}
        title={i18n.helpChannels}
        titleVariant={isMobile ? 'h5' : 'h4'}
        mb={3}
        align="left"
        eyebrowSize={14}
        titleSize={isMobile ? 28 : 40}
      />
      <Grid container spacing={2}>
        {CHANNELS.map((channel) => (
          <Grid item xs={12} lg={4} key={channel.id}>
            <ChannelCard
              label={channel.label}
              value={channel.value}
              href={channel.href}
              Icon={channel.Icon}
              isExternal={channel.isExternal}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

HelpChannels.propTypes = {
  isMobile: PropTypes.bool,
};

HelpChannels.defaultProps = {
  isMobile: false,
};

export default HelpChannels;
